import { required } from 'vuelidate/lib/validators'

export default {
  specialization: {
    type_specialization_id: {
      required
    },
    speciality_id: {
      required
    },
    entity_name: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/form/resources/validations.js